"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormValidator = exports.withFormValidation = exports.useFormValidation = exports.FormValidationConsumer = void 0;
var react_1 = __importStar(require("react"));
;
var Context = react_1.default.createContext({
    setValidator: function () { return null; },
    formErrors: {},
    valid: true,
});
function errorsReducer(errors, _a) {
    var id = _a.id, error = _a.error;
    var newErrors = __assign({}, errors);
    if (error) {
        newErrors[id] = error;
    }
    else {
        delete newErrors[id];
    }
    return newErrors;
}
function FormValidation(_a) {
    var children = _a.children;
    var _b = react_1.useReducer(errorsReducer, {}), formErrors = _b[0], setValidator = _b[1];
    return (react_1.default.createElement(Context.Provider, { value: {
            setValidator: setValidator,
            formErrors: formErrors,
            valid: Object.values(formErrors).length < 1,
        } }, children));
}
exports.default = FormValidation;
function FormValidationConsumer(_a) {
    var children = _a.children;
    return (react_1.default.createElement(Context.Consumer, null, children));
}
exports.FormValidationConsumer = FormValidationConsumer;
function useFormValidation() {
    return react_1.useContext(Context);
}
exports.useFormValidation = useFormValidation;
function withFormValidation(Component) {
    return function WrapperComponent(props) {
        return (react_1.default.createElement(FormValidation, null,
            react_1.default.createElement(Component, __assign({}, props))));
    };
}
exports.withFormValidation = withFormValidation;
var validatorCount = 0;
function useFormValidator(error, id) {
    var setValidator = useFormValidation().setValidator;
    var validatorId = react_1.useMemo(function () {
        if (id)
            return id;
        validatorCount++;
        return "validator-" + validatorCount;
    }, [id]);
    react_1.useEffect(function () {
        setValidator({
            id: validatorId,
            error: error
        });
    }, [error, setValidator, validatorId]);
    react_1.useEffect(function () {
        return function () { return setValidator({
            id: validatorId,
            error: false
        }); };
    }, [validatorId, setValidator]);
    return error;
}
exports.useFormValidator = useFormValidator;
